<template>

<div class="modal-card">

     <header class="modal-card-head "  >
         <b-button  type="is-danger" class="mr-5"  icon-left="alpha-x-box" @click="close" size="is-medium"  />
         <b-input class="ml-5" placeholder="Search Param" v-model="searchTxtParam"  ></b-input>
     </header>   
        <section class="modal-card-body " >
             <b-table
                 :data="dataLabParamsMasterReturnByCusNo"
                 draggable
                 @dragstart="dragstartCUS1"
                 @drop="dropCUS1"
                 @dragover="dragoverCUS1"
                 @dragleave="dragleaveCUS1"
             >  
             
                <b-table-column  label="No."  width="10%" v-slot="props">
                    {{props.index + 1}}
                </b-table-column>    
                <b-table-column field="label" label="PARAMS"   v-slot="props">
                    <text-highlight :queries="queries"> {{ props.row.label }} </text-highlight>
                </b-table-column>  
                <b-table-column field="order" label="ORDER" :visible="false"    v-slot="props">
                    {{ props.row.order }}
                </b-table-column>  
                 <b-table-column field="order" label="UUID" :visible="false"    v-slot="props">
                    {{ props.row.uuid }}
                </b-table-column>  
             </b-table>   




        </section>  
            <footer class="modal-card-foot"  >
                <b-button type="is-danger" @click="close">Close</b-button>    
            </footer>    
</div>    
</template>

<script>
import { mapState } from "vuex";
import { genUUID } from '@/utils.js'



export default {
    name : "SortCBCTable",

    created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()
                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
    },
    props:{
        cusNo : String, // "cus0", "cus1" ,"cus2"
    },
    mounted(){
        this.makeUUIDAllParams()
    },
    computed:{
            ...mapState({
                dataLabParamsMaster : state => state.master_data.dataLabParamsMaster,
                dataLabParamsMaster_1 : state => state.master_data.dataLabParamsMaster_1,
                dataLabParamsMaster_2 : state => state.master_data.dataLabParamsMaster_2,
            }),
            queries(){
                return this.searchTxtParam.split(" ");
            },
            dataLabParamsMasterReturnByCusNo(){
                const dataLabParamsMap = {
                        "cus0": this.dataLabParamsMaster,
                        "cus1": this.dataLabParamsMaster_1,
                        "cus2": this.dataLabParamsMaster_2
                        };

                return dataLabParamsMap[this.cusNo] || [];

            }
    },
    methods:{
        swapArrayElementsCUS1 (arr, indexA, indexB) {
                var temp = arr[indexA];
                arr.splice(indexA,1)
                arr.splice(indexB,0,temp)
        },
        dragstartCUS1 (payload) {
                this.draggingRow = payload.row
                this.draggingRowIndex = payload.index
                payload.event.dataTransfer.effectAllowed = 'copy'
        },
        dragoverCUS1(payload) {
                payload.event.dataTransfer.dropEffect = 'copy'
                payload.event.target.closest('tr').classList.add('is-selected')
                payload.event.preventDefault()
        },
        dragleaveCUS1(payload) {
            payload.event.target.closest('tr').classList.remove('is-selected')
            payload.event.preventDefault()
        },
        dropCUS1(payload) {
            payload.event.target.closest('tr').classList.remove('is-selected')
            const droppedOnRowIndex = payload.index
            this.$buefy.toast.open({
                message: `Moved ${this.draggingRow.first_name} from row ${this.draggingRowIndex + 1} to ${droppedOnRowIndex + 1}`,
                duration:500
            })

            if(this.cusNo=='cus0'){
              this.swapArrayElementsCUS1(this.dataLabParamsMaster , this.draggingRowIndex ,droppedOnRowIndex )
              this.dataLabParamsMaster[droppedOnRowIndex]['uuid'] = genUUID(10)
              this.dataLabParamsMaster[this.draggingRowIndex]['uuid'] = genUUID(10)  
            }
            else if(this.cusNo=='cus1'){
              this.swapArrayElementsCUS1(this.dataLabParamsMaster_1 , this.draggingRowIndex ,droppedOnRowIndex )
              this.dataLabParamsMaster_1[droppedOnRowIndex]['uuid'] = genUUID(10)
              this.dataLabParamsMaster_1[this.draggingRowIndex]['uuid'] = genUUID(10)  
            }
            else if(this.cusNo=='cus2'){
              this.swapArrayElementsCUS1(this.dataLabParamsMaster_2 , this.draggingRowIndex ,droppedOnRowIndex )
              this.dataLabParamsMaster_2[droppedOnRowIndex]['uuid'] = genUUID(10)
              this.dataLabParamsMaster_2[this.draggingRowIndex]['uuid'] = genUUID(10)  
            }







            

            this.makeOrder()

        },
        makeOrder(){
            if(this.cusNo=='cus0'){
              for(var i =0 ;i<=this.dataLabParamsMaster.length-1;i++){
                  this.dataLabParamsMaster[i].order = i
              }
            } else if(this.cusNo=='cus1'){
                for(var j =0 ;j<=this.dataLabParamsMaster_1.length-1;j++){
                  this.dataLabParamsMaster_1[j].order = j
              }
            } else if(this.cusNo=='cus2'){
                for(var k =0 ;k<=this.dataLabParamsMaster_2.length-1;k++){
                  this.dataLabParamsMaster_2[j].order = j
              }
            }   
        },
        makeUUIDAllParams(){
            if(this.cusNo=='cus0'){
                for(var a =0 ;a<=this.dataLabParamsMaster.length-1;a++){
                    this.dataLabParamsMaster[a].uuid = genUUID(10)
                }  
            }else if(this.cusNo=='cus1'){
                for(var b =0 ;b<=this.dataLabParamsMaster_1.length-1;b++){
                    this.dataLabParamsMaste_1[b].uuid = genUUID(10)
                }   
            }else if(this.cusNo=='cus2'){
                for(var c =0 ;c<=this.dataLabParamsMaster_2.length-1;c++){
                    this.dataLabParamsMaste_2[c].uuid = genUUID(10)
                }   
            }      
        },

        close(){
            this.$emit('close')
        },
    },
    data(){
        return {
          searchTxtParam : "",
        }
    }
}
</script>